// extracted by mini-css-extract-plugin
export default {"card_grid":"productCard_card_grid__-Haje"};